// Default section set for the "Case Study" email template (M11, requested
// 2026-06-06). It reuses the olive section-based builder — the user wanted a
// template "with sections" — so a case study is just a different default
// arrangement of the existing `header` / `case_study` / `footer` section types,
// in the order they asked for: title image → customer → problem → XOP solution
// → network diagram → benefits.
//
// Images are anchored to the public asset host via `toAbsoluteUrl` so they
// render in BOTH the preview and the sent email (the case_study HTML serializer
// emits `content` verbatim, so a relative `<img>` would 404 in a mail client).

import { type NewsletterSection, toAbsoluteUrl } from "./stock-images";

export function getCaseStudyDefaultSections(): NewsletterSection[] {
  return [
    {
      id: "header",
      type: "header",
      content: {
        // Header anchors `imageUrl` itself, so a root-relative path is fine.
        // No recipient/customer on the header — the body opens straight into
        // the story (subtitle renders as the small top-right date).
        title: "Customer Success Story",
        subtitle: "",
        imageUrl: "/stock-images/business-collaboration.jpg",
      },
    },
    {
      id: "challenge",
      type: "case_study",
      backgroundColor: "#ffffff",
      content: {
        heading: "The Challenge",
        title: "What they needed",
        content:
          "<p>Describe the problem the customer faced before XOP — the pain points, the constraints, and what was at stake.</p>",
      },
    },
    {
      id: "solution",
      type: "case_study",
      backgroundColor: "#f9fdf7",
      content: {
        heading: "The XOP Solution",
        title: "How XOP delivered",
        content:
          "<p>Describe the XOP solution deployed — which products and features solved the problem, and how it was rolled out.</p>",
      },
    },
    {
      id: "network-diagram",
      type: "case_study",
      backgroundColor: "#ffffff",
      content: {
        heading: "Network Diagram",
        title: "",
        // Anchored absolute so it survives into the email HTML. Swap the image
        // by editing this section (or paste your own diagram URL).
        content: `<p style="text-align: center; margin: 0;"><img src="${toAbsoluteUrl(
          "/stock-images/network-infrastructure.jpg",
        )}" alt="Network diagram" style="max-width: 100%; height: auto; border-radius: 8px;" /></p>`,
      },
    },
    {
      id: "benefits",
      type: "case_study",
      backgroundColor: "#f9fdf7",
      content: {
        heading: "The Results",
        title: "Key Benefits",
        content:
          "<ul><li>Benefit one — e.g. reduced downtime.</li><li>Benefit two — e.g. lower total cost.</li><li>Benefit three — e.g. faster response times.</li></ul>",
      },
    },
    {
      id: "footer",
      type: "footer",
      backgroundColor: "#2d3748",
      content: {},
    },
  ];
}
